import { render, staticRenderFns } from "./HealthAttorneys.vue?vue&type=template&id=83b206e4"
import script from "./HealthAttorneys.vue?vue&type=script&lang=js"
export * from "./HealthAttorneys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports